export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        GET_REGIONS: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/suppliers/regions',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log(state)
                    payload.th.prepareRegions(responseData.regions)
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
    }
}